module.exports = "<!--周选择 最大日期 最小日期-->\n<input week-picker week-data=\"weekData2\" max-date-value=\"20\" min-date-value=\"-30\"> \n{{weekData2|json}}";